import React from 'react';

export default function RadioGroup({ label, options, name, value, onChange, className = '' }) {
  return (
    <div className={`space-y-2 ${className}`}>
      {label && <label className="text-sm font-bold text-forest-green">{label}</label>}
      <div className="space-y-2">
        {options.map((opt) => (
          <label key={opt.value} className="flex items-start gap-3 cursor-pointer group">
            <div className="relative flex items-center justify-center mt-0.5">
              <input
                type="radio"
                name={name}
                value={opt.value}
                checked={value === opt.value}
                onChange={(e) => onChange(e.target.value)}
                className="peer sr-only"
              />
              <div className="w-5 h-5 rounded-full border-2 border-amber bg-cream peer-checked:border-forest-green transition-colors"></div>
              <div className="w-2.5 h-2.5 rounded-full bg-forest-green absolute opacity-0 peer-checked:opacity-100 transition-opacity"></div>
            </div>
            <div className="text-dark-green group-hover:text-forest-green transition-colors">
              <span className="block font-medium">{opt.label}</span>
              {opt.description && <span className="block text-xs text-muted mt-0.5">{opt.description}</span>}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}